<template>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="600" :styles="{top: '30px'}">
        <Form ref="from" :model="fromModel" :label-width="80" :rules="formValidate">
            <div v-if="showParent">
                <FormItem label="上级节点：">{{parentTitle}}</FormItem>
            </div>
            <FormItem label="分类名称" prop="courseTypeName" required error="分类名称不能为空">
                <Input v-model="fromModel.courseTypeName"/>
            </FormItem>
            <div v-if="!showParent">
                <FormItem label="图标：" prop="typeImg">
                    <upload-input :fileUrl="fromModel.typeImg" :fileSize="fileSize" fileWh="50*50" @on-change="handleUpload" width="300px" ref="upload"></upload-input>
                </FormItem>
            </div>
            <FormItem label="排序号" prop="sortOrder">
                <InputNumber v-model="fromModel.sortOrder"/>
                <span style="margin-left:5px">值越小越靠前</span>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text" @click="cancel">取消</Button>
            <Button type="primary" :loading="submitLoading" @click="submit">提交</Button>
        </div>
    </Modal>
</template>

<script>
    import {addCrouseType, editCrouseType} from "@/api/bus";
    import uploadInput from "@/views/my-components/flyme/upload-input";
    export default {
        name: "courseTypeModal",
        components: {
            uploadInput
        },
        data() {
            return {
                accessToken: {},
                modalType: 0,
                modalTitle: "",
                showParent: false,
                parentTitle: '',
                submitLoading: false,
                modalVisible: false,
                fileSize:100,
                fromModel: {
                    id:"",
                    parentId:"",
                    typeImg:"",
                    courseTypeName: "",
                    sortOrder: 0
                },
                formRules: {

                },
                formValidate: {
                    // 表单验证规则
                    courseTypeName: [{required: true, message: "分类名称不能为空", trigger: "blur"}]
                },
            }
        },
        methods: {
            init() {
                this.accessToken = {
                    accessToken: this.getStore("accessToken")
                };

            },
            add(node) {
                this.modalType=0;
                if (node&&node.id) {
                    this.showParent = true;
                    this.fromModel.parentId=node.id;
                    this.parentTitle = node.title;
                } else {
                    this.showParent = false;
                    this.fromModel.parentId=0;
                    this.parentTitle = "";
                }
                this.setModalVisible('添加-课程分类', true);
            },
            edit(node) {
                this.modalType=1;
                if (node&&node.id) {
                    this.fromModel.id = node.id;
                    this.fromModel.parentId=node.parentId;
                    this.fromModel.courseTypeName=node.title;
                    this.fromModel.sortOrder=node.sortOrder;
                    if(node.parentId==0){
                        this.showParent = false;
                        this.parentTitle = "";
                    }else{
                        this.showParent = true;
                        this.parentTitle = node.title;
                    }
                }
                this.setModalVisible('编辑-课程分类', true);
            },
            setModalVisible(title, visible) {
                this.modalTitle = title;
                this.modalVisible = visible;
            },
            handleUpload(v) {
                this.fromModel.typeImg = v.fileUrl;
            },
            cancel() {
                this.modalVisible = false;
            },
            submit() {
                this.$refs.from.validate(valid => {
                    if (valid) {
                        if (this.modalType === 0) {
                            // 避免编辑后传入id
                            delete this.fromModel.id;
                            this.submitLoading = true;
                            addCrouseType(this.fromModel).then(res => {
                                this.submitLoading = false;
                                if (res.status === true) {
                                    this.$Message.success("添加成功");
                                    this.$parent.getTreeData();
                                    this.modalVisible = false;
                                }
                            });
                        } else {
                            // 编辑
                            editCrouseType(this.fromModel).then(res => {
                                this.submitLoading = false;
                                if (res.status === true) {
                                    this.$Message.success("修改成功");
                                    this.$parent.getTreeData();
                                    this.modalVisible = false;
                                }
                            });
                        }
                    }
                });
            }
        },
        mounted() {
            this.init();
        }
    }
</script>

<style>

</style>